import BarChartIcon from '@mui/icons-material/BarChart';
import { Alert, Card, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { BarChart } from '@mui/x-charts';
import { ResponsiveContainer } from 'recharts';
import { PALETTE } from '../../../../configurations/global.config';
import { cardHeaderStyle, cardStyle } from '../../styles/grid-card.style';
import { WidgetProps } from '../home';
import { useContext } from 'react';
import { OrgSettingsContext } from '../../../../contexts/org-settings-context';

function DeliveredOrdersHistoryWidget({
  stats,
  isLoading,
  errorMessage,
}: WidgetProps) {
  const { color } = useContext(OrgSettingsContext);
  return isLoading ? (
    <CircularProgress />
  ) : (
    <>
      {errorMessage !== '' && <Alert severity="error">{errorMessage}</Alert>}

      {stats !== undefined && (
        <ResponsiveContainer height={350}>
          <BarChart
            xAxis={[
              {
                scaleType: 'band',
                data: [
                  'January',
                  'February',
                  'March',
                  'April',
                  'May',
                  'June',
                  'July',
                  'August',
                  'September',
                  'October',
                  'November',
                  'December',
                ],
              },
            ]}
            series={[
              {
                data: stats.order_results_per_month.delivered_standard,
                color: PALETTE[2],
                label: 'Delivered To Customer',
              },
              {
                data: stats.order_results_per_month.delivered_return,
                color: PALETTE[4],
                label: 'RTO',
              },
              {
                data: stats.order_results_per_month.cancelled,
                color: PALETTE[0],
                label: 'Cancelled',
              },
            ]}
          />
        </ResponsiveContainer>
      )}
    </>
  );
}

export default DeliveredOrdersHistoryWidget;
